<div class="shared-widgets">
    @if (shouldShowPxUserSurvey$ | async) {
        <dcp-px-survey-widget></dcp-px-survey-widget>
    }
    @if (showSupportWidget$ | async) {
        <dcp-checkout-support-widget
            [componentData]="componentData"
        ></dcp-checkout-support-widget>
    }
</div>
